/* eslint-disable */
// @ts-nocheck

import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Player } from "@lottiefiles/react-lottie-player";
import {
  Dropdown,
  FilterableMultiSelect,
  FileUploaderDropContainer,
  FileUploader,
  FileUploaderItem,
} from "@carbon/react";
import Button, { Icons } from "../components/buttons/Button";
import { errorAlert, makeApiRequest, successAlert } from "../util";
import TextField from "../components/inputs/TextField";
import NumberField from "../components/inputs/NumberField";
import MultiselectSearchField from "../components/inputs/MultiselectSearchField";
import SidePanel from "../components/sidePanel/SidePanel";
import succ from "../assets/lottie/success.json";
import SuccessAnimation from "../ui/animation/SuccessAnimation";
import { Add } from "@carbon/icons-react";
import Form from "../ui/Form/Form";
import AuthContext from "../store/authContext";

const ESDemo = () => {
  const [username, setUsername] = React.useState("");
  const [show, setShow] = React.useState(false);
  const items = ["HEX", "DEC"];
  const [currentItem, setCurrentItem] = useState(items[0]);
  const [startUploading, setStartUploading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState([]);
  const [errorFile, setErrorFile] = useState([]);
  const [fileName, setFileName] = useState("");
  const [showReport, setShowReport] = useState(false);
  const [loading, setLoading] = useState(false);
  const [finalResult, setFinalResult] = useState();

  const { token } = useContext(AuthContext);

  const navigate = useNavigate();

  let payload = [];
  let header = [];
  let fileReader;
  let finalFile = [];
  let filewitherror = [];

  const handleFileValidation = (
    file: {
      "org-id": string;
      "message-id": number;
      "canned-text": string;
    }[]
  ) => {
    file.map((entry) => {
      if (entry[0]["message-id"] >= 0 && entry[0]["message-id"] <= 65535) {
        if (entry[0]["canned-text"] && entry[0]["canned-text"].length >= 1) {
          finalFile.push(entry);
        } else {
          let newObj = {
            ...entry[0],
            reason: "canned-text is a required field",
          };
          errorFile.push(newObj);
        }
      } else {
        let newObj = {
          ...entry[0],
          reason:
            "message-id is a required field and should be in the range 0-65535",
        };
        errorFile.push(newObj);
      }
    });
    setUploadedFile(finalFile);
  };

  const handleFileRead = (e) => {
    const content = fileReader.result;
    const actualContent = content.split(/[\r\n]+/).map((ele) => ele.split(","));
    header = actualContent[0];
    for (let i = 1; i < actualContent.length; i++) {
      let result = [];
      let obj = {};
      actualContent[i].forEach((ele, i) => {
        let key = header[i];
        obj = { ...obj, [key]: ele };
      });
      result.push(obj);
      payload.push(result);
    }
    setStartUploading(false);
    setUploadedFile(payload);
    handleFileValidation(payload);
  };

  const handleFileChosen = (file) => {
    fileReader = new FileReader();
    fileReader.readAsText(file);
    fileReader.onloadend = handleFileRead;
  };

  const handleFileUpload = async (entry) => {
    let body = JSON.stringify({
      "MSG-ID": entry[0]["message-id"],
      "CANNED-TEXT": entry[0]["canned-text"],
    });
    try {
      let response = await makeApiRequest<{ Ref: string }>({
        path: `/api/v1/lmr-msgs`,
        method: "POST",
        body: body,
        token,
        org: entry[0]["org-id"],
      });

      finalResult.push(response);

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      // errorAlert(e);
      let newObj = { ...entry[0], reason: e };
      errorFile.push(newObj);
    }
  };

  const handleFileSubmit = () => {
    let result;
    setStartUploading(true);
    setShowReport(false);
    try {
      uploadedFile.map((entry) => handleFileUpload(entry));
    } catch (e) {
      setErrorFile([...errorFile, ...result]);
    } finally {
      setStartUploading(false);
    }
  };

  const handleDelete = (e) => {
    setUploadedFile([]);
    setFileName("");
    setShowReport(false);
  };

  return (
    <div className="demo">
      <div className="mb-4"></div>
      <FileUploader
        labelTitle="Upload CSV file"
        labelDescription="Only .csv files are supported."
        buttonLabel="Add file"
        buttonKind="primary"
        size="md"
        filenameStatus={startUploading ? "uploading" : "edit"}
        accept={[".csv", "text/csv"]}
        multiple={false}
        disabled={false}
        iconDescription="Delete file"
        name="bulk upload"
        onChange={(e) => {
          handleFileChosen(e.target.files[0]);
        }}
      />
      <FileUploaderDropContainer
        accept={[".csv", "text/csv"]}
        labelText="Drag and drop files here or click to upload"
        multiple={false}
        filenameStatus={startUploading ? "uploading" : "edit"}
        onAddFiles={(e) => {
          setStartUploading(true);
          setFileName(e.target.files[0].name);
          handleFileChosen(e.target.files[0]);
        }}
      />
      {fileName ? (
        <>
          <FileUploaderItem
            name={fileName}
            status="edit"
            onDelete={handleDelete}
          />
          <Button
            label="Upload"
            disabled={startUploading}
            onClick={() => {
              handleFileSubmit();
              setShowReport(true);
            }}
          />
        </>
      ) : (
        <></>
      )}

      {!startUploading ? (
        <>
          <h4>Number of failed Entries : {errorFile.length}</h4>
          <h4>Number of successfull Entries : {uploadedFile.length}</h4>
          <Button
            className="w-sm"
            type="button"
            onClick={() => {
              const result = errorFile.map((entry) =>
                Object.values(entry).toString()
              );
            }}
            label="DownLoad CSV"
          />
        </>
      ) : (
        <></>
      )}
      <>
        <p> it starts from here</p>
        <h5 className="instruction-text">
          {" "}
          Lorem Ipsum is simply dummy text of the printing and industry{" "}
          <a> Download Template CSV File </a>{" "}
        </h5>
        <FileUploaderDropContainer
          labelTitle="Upload files"
          labelText="Drag and drop files here or click to upload"
          onAddFiles={() => console.log("logged")}
          disabled
        />

        <div className="file-block flex items-center justify-between">
          <div> Uploaded File </div>
          <Button
            kind="primary"
            className="border-none no-outline w-0 p-0 mr-3"
            type="button"
            icon={Icons.Edit}
            label="Uploaded File"
            onClick={() => null}
          />
        </div>

        <div className="instruction-list">
          <h4> Instruction </h4>
          <ul>
            <li> Maximum 1000 record allowed in one entry </li>
            <li> Only one file at a time is allowed </li>
          </ul>
        </div>

        <h5 className="instruction-text flex items-center mt-4">
          <svg
            className="mr-2"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.00016 0.332031C3.32016 0.332031 0.333496 3.3187 0.333496 6.9987C0.333496 10.6787 3.32016 13.6654 7.00016 13.6654C10.6802 13.6654 13.6668 10.6787 13.6668 6.9987C13.6668 3.3187 10.6802 0.332031 7.00016 0.332031ZM7.00016 7.66536C6.6335 7.66536 6.3335 7.36536 6.3335 6.9987V4.33203C6.3335 3.96536 6.6335 3.66536 7.00016 3.66536C7.36683 3.66536 7.66683 3.96536 7.66683 4.33203V6.9987C7.66683 7.36536 7.36683 7.66536 7.00016 7.66536ZM7.66683 10.332H6.3335V8.9987H7.66683V10.332Z"
              fill="#781C1C"
            />
          </svg>
          Lorem Ipsum is simply dummy text of the printing and industry{" "}
          <a className="ml-1">Download Error Report </a>
        </h5>
        <></>
      </>
      {/* {uploadedFile.map((file, index) => (
        <FileUploaderItem
          key={index}
          name={uploadedFile}
          status="edit"
          // onDelete={(event) => handleDelete(event, index)}
        />
      ))} */}
      {/* const [files, setFiles] = useState([]); */}
      {/* const handleDrop = (event, { addedFiles }) => {
    event.stopPropagation();
    event.preventDefault();
 
    setFiles((prevFiles) => [...prevFiles, ...addedFiles]);
  };
 
  const handleDelete = (event, index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  }; */}
      {/* <div className="mb-4">
        <MultiselectSearchField
          titleText="CHANNEL IDS"
          placeholder="Select DFSI Channel Ids"
          items={[
            { id: "option-0", text: "Option 0" },
            { id: "option-1", text: "Option 1" },
            { id: "option-2", text: "Option 2" },
            { id: "option-3", text: "Option 3" },
            { id: "option-4", text: "Option 4" },
            { id: "option-5", text: "Option 5" },
            { id: "option-6", text: "Option 6" },
            { id: "option-7", text: "Option 7" },
            { id: "option-8", text: "Option 8" },
            { id: "option-9", text: "Option 9" },
            { id: "option-10", text: "Option 10" },
          ]}
          itemToString={(item) => (item ? item.text : "")}
          tooltipText="Testing"
          onChange={() => null}
          required
        />

        <div className="hexdec-block">
          <div className="input-wrapper">
            <Dropdown
              className="input-dropdown"
              items={items}
              selectedItem={currentItem}
              onChange={({ selectedItem }) => setCurrentItem(selectedItem)}
            />
            <div className="input-field">
              {currentItem === "HEX" ? (
                <TextField
                  labelText="RADIO-IPV4-ADDR"
                  onChange={() => null}
                  required
                  tooltipText="Test demo content"
                />
              ) : (
                <NumberField
                  label="RADIO-IPV4-ADDR"
                  value={2}
                  max={10}
                  min={0}
                  tooltipText="This property defines the suggested priority of the group when queuing group calls on a busy system."
                  required
                  onChange={() => null}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <button type="button" onClick={() => setShow(true)}>
        show
      </button> */}
      {/* <SidePanel
        toggleFilterPanel={() => null}
        showDelete={false}
        onDelete={() => null}
        panelName="MCPTT Groups"
        className="sidepanel sidepanel-view fixed z-40 h-full transform transition-transform ease-in duration-150 bg-white"
        panelContent={
          <div className="panel-content">
            <div className="data-tabs">
              <div className="inner-datacontent">
                <div className="tab-header">
                  <h3> MC Group </h3>
                  <div className="tab-header-buttons">
                    <Button
                      kind="tertiary"
                      className="border-none no-outline w-0 p-0 mr-3"
                      type="button"
                      icon={Icons.Edit}
                      label="Edit"
                      onClick={() => null}
                    />
                  </div>
                </div>

                <div className="readonly-data">
                  <ul>
                    <li className="flex items-center">
                      <h5> Reference ID </h5>
                      <div className="data-content">
                        <span> a2c162e9439ce9439c17162e17 </span>
                        <Button
                          kind="ghost"
                          className="bg-btn"
                          icon={Icons.Copy}
                        />
                      </div>
                    </li>

                    <li className="flex items-center">
                      <h5> Creation Date </h5>
                      <div className="data-content">
                        <span> 2023-04-24T08:56:00 </span>
                      </div>
                    </li>

                    <li className="flex items-center">
                      <h5> Modification Date </h5>
                      <div className="data-content">
                        <span> 2023-05-30T05:43:39 </span>
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="grid grid-cols-1 gap-4 form-control">
                  <TextField
                    disabled
                    labelText="MCPTT-GID"
                    placeholder="sip:10111112345678956@mobile.att.com"
                    value="sip:10111112345678956@mobile.att.com "
                    tooltipText="The ID of the MC Group."
                    required
                    onChange={() => null}
                  />

                  <TextField
                    disabled
                    labelText="MAPPED-P25-TG-ID"
                    placeholder="sip:10111112345678956@mobile.att.com"
                    value="sip:10111112345678956@mobile.att.com "
                    tooltipText="The ID of the MC Group."
                    required
                    onChange={() => null}
                  />

                  <TextField
                    disabled
                    labelText="MAPPED-DFSI-TG-ID:"
                    placeholder="sip:10111112345678956@mobile.att.com"
                    value="sip:10111112345678956@mobile.att.com "
                    tooltipText="The ID of the MC Group."
                    required
                    onChange={() => null}
                  />
                </div>
              </div>

              <div className="inner-datacontent mt-5">
                <div className="tab-header">
                  <h3>Group Profile </h3>
                  <div className="tab-header-buttons">
                    <Button
                      className="w-sm mr-2"
                      type="button"
                      kind="tertiary"
                      disabled={false}
                      label="Cancel"
                      onClick={() => null}
                    />
                    <Button
                      className="w-sm"
                      type="button"
                      onClick={() => null}
                      label="Save"
                    />
                  </div>
                </div>

                <div className="readonly-data">
                  <ul>
                    <li className="flex items-center">
                      <h5> Reference ID </h5>
                      <div className="data-content">
                        <span> a2c162e9439ce9439c17162e17 </span>
                        <Button
                          kind="ghost"
                          className="bg-btn"
                          icon={Icons.Copy}
                        />
                      </div>
                    </li>

                    <li className="flex items-center">
                      <h5> Creation Date </h5>
                      <div className="data-content">
                        <span> 2023-04-24T08:56:00 </span>
                      </div>
                    </li>

                    <li className="flex items-center">
                      <h5> Modification Date </h5>
                      <div className="data-content">
                        <span> 2023-05-30T05:43:39 </span>
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="grid grid-cols-2 gap-4 form-control">
                  <NumberField
                    disabled
                    label="GROUP-ACCESS-PERMISSION"
                    value={2}
                    max={0}
                    min={0}
                    tooltipText="This property defines whether or not the group is allowed to make non-emergency calls at the Serving RFSS. Zero (0) indicates non-emergency calls on the group MAY NOT be placed from the Serving RFSS. 
                    "
                    required
                    onChange={() => null}
                  />

                  <NumberField
                    disabled
                    label="GROUP-PRIORITY"
                    value={2}
                    max={0}
                    min={0}
                    tooltipText="This property defines the suggested priority of the group when queuing group calls on a busy system."
                    required
                    onChange={() => null}
                  />

                  <NumberField
                    disabled
                    label="GROUP-EMERGENCY-CAPABLE"
                    value={10}
                    max={0}
                    min={0}
                    tooltipText="This property defines whether or not emergency calls may be made on the group. Zero (0) indicates that emergency calls are not allowed."
                    required
                    onChange={() => null}
                  />

                  <NumberField
                    disabled
                    label="GROUP-EMERGENCY-PREEMPTION"
                    value={10}
                    max={0}
                    min={0}
                    tooltipText=" This property defines the type of pre-emption to be applied for emergency calls, Zero (0) indicates non-ruthless, One (1) indicates ruthless."
                    required
                    onChange={() => null}
                  />

                  <NumberField
                    disabled
                    label="GROUP-RF-HANG-TIME"
                    value={10}
                    max={0}
                    min={0}
                    tooltipText="This property defines the RF hang-timer for the group. The integer value is the RF hang-timer in tenths of seconds and is limited to the range 0 – 32767"
                    required
                    onChange={() => null}
                  />

                  <NumberField
                    disabled
                    label="GROUP-CC-SETUP-TIME"
                    value={10}
                    max={0}
                    min={0}
                    tooltipText="This property defines the maximum setup time for a confirmed call on the group. Zero (0) indicates that the call is unconfirmed. A value in the range 1-32766 specifies the setup time in tenths of seconds and indicates that the call is confirmed. A value of 32767 indicates an infinite setup time, and indicates that the call is confirmed. "
                    required
                    onChange={() => null}
                  />

                  <NumberField
                    disabled
                    label="GROUP-INTERRUPT-MODE"
                    value={10}
                    max={0}
                    min={0}
                    tooltipText="This property defines the audio interrupt mode of the talk group. Zero (0) indicates that audio interruption by SUs within a talk group call is never allowed, One (1) indicates that it is allowed based on SU priority, and Two (2) indicates that it is always allowed"
                    required
                    onChange={() => null}
                  />

                  <NumberField
                    disabled
                    label="GROUP-SECURITY"
                    value={10}
                    max={0}
                    min={0}
                    tooltipText="This property defines the allowable security level (1=Clear, 2=Secure or 3=Both) of the call"
                    required
                    onChange={() => null}
                  />

                  <NumberField
                    disabled
                    label="GROUP-EXPIRATION-PERIOD"
                    value={10}
                    max={0}
                    min={0}
                    tooltipText="For MCPTT groups (IWF is Home RFSS), TODO RR"
                    required
                    onChange={() => null}
                  />
                </div>
              </div>
            </div>
          </div>
        }
      /> */}
      <div className="mb-4">
        {/* <Button
          className="w-full"
          label="Create new"
          icon={Icons.Add}
          disabled
        /> */}

        {/* <Button label="" icon={Icons.Add} onClick={() => alert("clicked")} /> */}
      </div>
      <div className="mb-4">
        {/* <Button
          kind="tertiary"
          className="w-full"
          label="Advanced search"
          loading
        /> */}
      </div>
      <div className="mb-4">
        {/* <Button
          kind="danger"
          className="w-full"
          label="Delete"
          loading
          icon={Icons.Delete}
        /> */}
      </div>
      <div className="mb-4">
        {/* <Button
          kind="tertiary"
          className="border-none no-outline p-0 mr-3"
          label="Edit"
          icon={Icons.Edit}
          loading
        /> */}
      </div>
      <div className="mb-4">
        {/* <Button
          kind="tertiary"
          className="border-none no-outline p-0"
          label="Delete"
          icon={Icons.Delete}
        /> */}
      </div>
      <div className="mb-4">
        {/* <Button kind="ghost" className="bg-btn" icon={Icons.Copy} /> */}
      </div>
      <div className="mb-4">
        {/* <TextField
          placeholder="Username"
          labelText="Username"
          disabled={false}
          value={username}
          onChange={(value) => {
            setUsername(value);
          }}
        /> */}
      </div>
      {/* <h1>Before</h1>
      {show ? <SuccessAnimation onComplete={() => setShow(false)} /> : null}
      <h2>After</h2> */}
    </div>
  );
};
export default ESDemo;
